module.exports = __webpack_public_path__ + "static/contactus-e5d4d87ed228c793ed9ac0e4c751f6a9.svg";